<template>
	<div class="alfa_settings_block default_radius" :class="{'md-error': config.isDeprecated}">
		<i class="fa fa-times close secondary_color pointer" @click="remove"/>
		<div class="flex flex_column">
			<div class="flex">
				<div class="flex flex_column" style="width: 56%;">
					<div class="flex">
						<div class="flex_1 flex flex_items_center text_left box_bg_color_light default_radius"
							 :class="{'validation-error-border': config.isDeprecated }"
							 style="margin-bottom: 10px; margin-top: 13px;"
						>
							<span class="w_100 margin_horizontal"> {{ config.translation }}</span>
							<el-tooltip :open-delay="300" placement="bottom" v-if="config.tooltip" class="margin_horizontal">
								<span slot="content" v-html="formatAsHtml(config.tooltip)"></span>
								<i class="fa fa-info-circle secondary_color" aria-hidden="true"/>
							</el-tooltip>
							<span v-if="config.isDeprecated" class="validation-error margin_r">{{ $t("common.validation.messages.deprecated") }}</span>
						</div>
						<div style="width: 5%;"></div>
						<md-field :class="[{ 'md-error': errors.has('filterType') }]" class="filter_select no-line" style="max-width: 130px;" >
							<TbSelect v-model="conditionSetting.filterType" md-dense
									  :options="filterOptions"
									  options-value-field="id"
									  options-display-field="displayValue"
									  :disabled="forceFilterType"
									  :placeholder="$t('common.alfa.filterPlaceholder')"
									  class="default_radius"
									  data-vv-name="filterType"
									  v-validate="modelValidations.filterType"
									  :required="modelValidations.filterType.required"
							/>
						</md-field>
					</div>
					<div v-if="renderValuesListStyle" class="flex_1 border_grey default_radius text_left" style="padding: 0 7px 7px 7px;">
						<TreeCheckableList v-if="renderValuesTreeStyle"
										   v-model="conditionSetting.value"
										   :options="allowedValueOptions.values"
										   :options-value-field=allowedValueOptions.valueField
										   :options-display-getter="allowedValueOptions.displayGetter"
										   :show-only-checked="true"
										   :tree-class="[selectedFilterType !== enumDef.alfaFilterType.IsNot ? 'md-primary' : 'md-block', 'tree-dense']"
										   style="max-height: 260px;"
						/>
						<TagList v-else
								 v-model="conditionSetting.value"
								 :tag-display-getter="getTagDisplayValue"
								 :tag-class="selectedFilterType !== enumDef.alfaFilterType.IsNot ? 'md-primary' : 'md-block'"
								 style="max-height: 159px;"
						/>
					</div>
				</div>
				<div style="width: 2%;"></div>
				<div class="flex" style="width: 42%;">
					<!-- Numeric inputs -->
					<template v-if="renderValuesNumericStyle">
						<!-- Min + Max -->
						<div v-if="doesSelectedFilterAllowMultipleValues" class="flex flex_column flex_1">
							<md-field :class="[{ 'md-error': errors.has('minInput')}]">
								<label>{{ $t("common.min") }}</label>
								<MoneyAmountInput v-model="conditionSetting.value[0]"
												  :as-percentage-rate="isInputAsPercentageRate"
												  :key="'minInput' + selectedValueType"
												  class="text_right"
												  data-vv-name="minInput"
												  v-validate="modelValidations.minInput"
												  :required="modelValidations.minInput.required"
								/>
								<span v-if="errors.has('minInput')" class="validation-error margin_l">{{ errors.first("minInput") }}</span>
							</md-field>
							<md-field :class="[{ 'md-error': errors.has('maxInput')}]">
								<label>{{ $t("common.max") }}</label>
								<MoneyAmountInput v-model="conditionSetting.value[1]"
												  :as-percentage-rate="isInputAsPercentageRate"
												  :key="'maxInput' + selectedValueType"
												  class="text_right"
												  data-vv-name="maxInput"
												  v-validate="modelValidations.maxInput"
												  :required="modelValidations.maxInput.required"
								/>
								<span v-if="errors.has('maxInput')" class="validation-error margin_l">{{ errors.first("maxInput") }}</span>
							</md-field>
						</div>
						<!-- Single input -->
						<md-field v-else :class="[{ 'md-error': errors.has('singleInput')}]">
							<label>{{ $t("common.input") }}</label>
							<MoneyAmountInput v-model="conditionSetting.value"
											  :as-percentage-rate="isInputAsPercentageRate"
											  :key="'singleInput' + selectedValueType"
											  class="text_right"
											  data-vv-name="singleInput"
											  v-validate="modelValidations.singleInput"
											  :required="modelValidations.singleInput.required"
							/>
							<span v-if="errors.has('singleInput')" class="validation-error margin_l">{{ errors.first("singleInput") }}</span>
						</md-field>
						<!-- Value type selection as % or amount -->
						<div v-if="config.valueTypes.length > 1" style="width: 120px" class="margin_l">
							<md-field :class="[{ 'md-error': errors.has('valueType') }]">
								<TbSelect v-model="conditionSetting.valueType" md-dense
										  :options="valueTypeOptions"
										  options-value-field="id"
										  options-display-field="displayValue"
										  data-vv-name="valueType"
										  v-validate="modelValidations.valueType"
										  :required="modelValidations.valueType.required"
										  content-size="xs"
								/>
							</md-field>
						</div>
					</template>
					<!-- List inputs -->
					<template v-else-if="renderValuesListStyle">
						<div class="flex border_grey default_radius flex_1"
								  style="min-height: 150px; padding: 7px; margin-top: 13px">
							<TreeCheckableList v-if="renderValuesTreeStyle"
											   v-model="conditionSetting.value"
											   :search-allow="true"
											   :options="allowedValueOptions.values"
											   :options-value-field=allowedValueOptions.valueField
											   :options-display-getter="allowedValueOptions.displayGetter"
											   :tree-class="['md-primary', 'tree-dense']"
											   style="max-height: 300px;"
							/>
							<SelectList v-else
										v-model="conditionSetting.value"
										:search-allow="true"
										:options="allowedValueOptions.values"
										:options-value-field="allowedValueOptions.valueField"
										:options-display-field="allowedValueOptions.displayField"
										style="max-height: 205px;"
							/>
						</div>
					</template>
					<template v-else>
						<div>This setup is currently not supported</div>
					</template>
				</div>
			</div>
			<span v-if="renderValuesListStyle" class="secondary_color">
				{{ listSelectionHint }}
			</span>
		</div>

	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";
import SelectList from "@/components/templates/common/SelectList";
import TagList from "@/components/templates/common/TagList";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";
import {formatAsHtml} from "@/common/format";
import TreeCheckableList from "@/components/templates/common/TreeCheckableList.vue";

export default {
	components: { TreeCheckableList, TagList, SelectList, MoneyAmountInput },
	props: {
		conditionSetting: { type: Object, default: { key: "", filterType: null, value: null, valueType: null } }, // Object including selected condition, filter and values
		config: { type: Object, default: { key: "", translation: "", tooltip: null, filterTypes: [], valueTypes: [], isDeprecated: false } }, // Config of allowed condition options, filters and value type
		allowedValuesGetter: { type: Function, default: null }, // Function to load potential values based on a value type and info on how to display them
		forceFilterType: { type: Boolean, default: false }, // Enforce selection of the first allowed filter type and disable changing it
		listSelectionHint: { type: String, default: "" }, // A special hint shown in case selection supports list values
		currency: { type: String, default: "" }
	},
	data() {
		return {
			modelValidations: {
				filterType: {
					required: true
				},
				singleInput: {
					required: true,
					min_value: 0
				},
				minInput: {
					required: true,
					min_value: 0
				},
				maxInput: {
					required: true,
					min_value: 0
				},
				valueType: {
					required: true
				}
			},
			enumDef: enumDef,
		};
	},
	created() {
		if (this.config.filterTypes.length === 1 || this.forceFilterType) {
			this.conditionSetting.filterType = this.config.filterTypes[0];
			this.forceFilterType = true;
		}

		// Make sure the value has a proper array structure, so the list selection works properly
		// even if no filter is selected yet
		if (this.conditionSetting.value == null && this.renderValuesListStyle) {
			this.conditionSetting.value = [];
		}

		if (this.conditionSetting.valueType === null) {
			this.conditionSetting.valueType = this.config.valueTypes[0];
		}

		this.updateValueValidations();
	},
	computed: {
		renderValuesNumericStyle() {
			return enumDef.alfaFilterType.isNumeric(this.config.filterTypes[0]);
		},
		renderValuesListStyle() {
			return enumDef.alfaFilterType.isList(this.config.filterTypes[0]);
		},
		renderValuesTreeStyle() {
			return this.renderValuesListStyle && this.allowedValueOptions.renderListAsTree;
		},
		isSelectedFilterNumericType() {
			return enumDef.alfaFilterType.isNumeric(this.selectedFilterType);
		},
		isSelectedFilterListType() {
			return enumDef.alfaFilterType.isList(this.selectedFilterType);
		},
		doesSelectedFilterAllowMultipleValues() {
			return this.isSelectedFilterListType || this.selectedFilterType === enumDef.alfaFilterType.IsBetween;
		},
		allowedValueOptions() {
			return this.allowedValuesGetter
				? this.allowedValuesGetter(this.selectedValueType)
				: { values: [], valueField: "", displayField: "" };
		},
		filterOptions() {
			return this.config.filterTypes
				.map(filterType => {
					return {
						id: filterType,
						displayValue: this.$t(enumDef.alfaFilterType.properties[filterType].key)
					};
				});
		},
		valueTypeOptions() {
			return this.config.valueTypes
				.map(valueType => {
					return {
						id: valueType,
						displayValue: valueType === enumDef.alfaValueType.PercentageRate ? this.$t("common.alfa.percentOfTotal") :
									  valueType === enumDef.alfaValueType.Number 		 ? this.currency :
									  ""
					};
				});
		},
		selectedFilterType() {
			return this.conditionSetting.filterType;
		},
		selectedValueType() {
			return this.conditionSetting.valueType;
		},
		isInputAsPercentageRate() {
			return this.selectedValueType === enumDef.alfaValueType.PercentageRate;
		}
	},
	methods: {
		formatAsHtml,
		getTagDisplayValue(tag) {
			if (this.allowedValueOptions.displayField) {
				let value = this.allowedValueOptions.values.find(value => value === tag || value[this.allowedValueOptions.valueField] === tag);
				return value[this.allowedValueOptions.displayField];
			}

			return tag;
		},
		remove() {
			this.$emit("remove", this.conditionSetting);
		},
		updateValueAfterFilterTypeChanged() {
			if (this.isSelectedFilterNumericType) {
				if (this.doesSelectedFilterAllowMultipleValues && !(this.conditionSetting.value instanceof Array)) {
					// Multiple numerical values are now supported, but we only have a single one yet, so we
					// convert the value structure to an array with the previous values as first element.
					this.conditionSetting.value = [this.conditionSetting.value, null];
				} else if (this.conditionSetting.value instanceof Array) {
					// Only a single numerical value is now supported, but we have multiple ones so far, so we
					// convert the value structure to a single number keeping the first previous value.
					this.conditionSetting.value = this.conditionSetting.value[0];
				}
			} else if (this.isSelectedFilterListType) {
				// Value structure is always a list, so no need for any conversions here
			}
		},
		clearValueAfterValueTypeChanged() {
			if (this.conditionSetting.value instanceof Array) {
				this.conditionSetting.value = this.conditionSetting.value.map(() => null);
			} else {
				this.conditionSetting.value = null;
			}
		},
		updateValueValidations() {
			if (this.isInputAsPercentageRate) {
				this.modelValidations.singleInput.is_percentage_rate = true;
				this.modelValidations.minInput.is_percentage_rate = true;
				this.modelValidations.maxInput.is_percentage_rate = true;
			} else {
				delete this.modelValidations.singleInput.is_percentage_rate;
				delete this.modelValidations.minInput.is_percentage_rate;
				delete this.modelValidations.maxInput.is_percentage_rate;
			}
		}
	},
	watch: {
		selectedFilterType() {
			this.updateValueAfterFilterTypeChanged();
		},
		selectedValueType() {
			this.updateValueValidations();
			this.clearValueAfterValueTypeChanged();
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/base_variables.scss";
@import "alfa.scss";

.alfa_settings_block {
	position: relative;
	background-color: #FFFFFF;
	padding: 1rem;
	border: 2px solid $accent-color;

	> i.close {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	.filter_select {
		.md-select::v-deep {
			background-color: $alfa_light_grey;

			input {
				padding-left: 1rem;
				padding-right: 1rem;
			}
		}
	}

	&.md-error {
		border-color: $invalid-color;
	}
}
</style>